import React, { useEffect, useState } from "react";
import StaffModal from "../components/StaffModal";
import { fetchStaffList, addStaff, deleteStaff } from "../common";
import { Edit, SimpleForm, TextInput, SelectInput, required, TopToolbar, Button, useRedirect, useRecordContext, DateInput, AutocompleteInput, useNotify, RadioButtonGroupInput, useGetOne, FileInput, FileField, Toolbar, SaveButton, DeleteButton } from "react-admin";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Divider, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { cleanRangeChoices, getNameAndCompanyNamewithAddress } from "../common";
import NoteAddIcon from '@mui/icons-material/NoteAdd';


const CleanHistoryEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const { id } = useParams();
  const [customers, setCustomers] = useState([]);
  const [invoiceHistory, setInvoiceHistory] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [isNew, setisNew] = useState(-1);
  const [isPay, setIsPay] = useState(0);
  const [previousIsPay, setPreviousIsPay] = useState(0);
  const [invoiceId, setInvoiceId] = useState(null);
  const [pumpingPay, setPumpingPay] = useState(0);
  const [pumpingWeigh, setPumpingWeigh] = useState(0);
  const [invoiceAmount, setInvoiceAmount] = useState(0);

  const { data, isLoading } = useGetOne("cleanHistory", { id });

  useEffect(() => {
    console.log("lodaing:", isLoading);
    if (!isLoading && data) {
      console.log(data);
      setCustomerId(data.customerId);
      setInvoiceId(data.invoiceId);
      setIsPay(data.isPay);
      setPreviousIsPay(data.isPay);
      setPumpingPay(data.pumpingPay);
      setPumpingWeigh(data.pumpingWeigh);
    }
  }, [isLoading])

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/clean`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        console.log(data);
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/invoiceHistory/customer/${customerId}`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        console.log(data);
        setInvoiceHistory(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    if (customerId) {
      fetchInvoice();
    }
  }, [customerId])

  useEffect(() => {
    setInvoiceAmount(pumpingPay * pumpingWeigh);
  }, [pumpingPay, pumpingWeigh]);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, marginBottom: -2 }}>
      <TopToolbar>
        <Button
          label="請求書を作成"
          onClick={() => redirect(`/invoice-form/cleanHistory/${id}`)}
          startIcon={<NoteAddIcon />}
        />
        <Button
          label="清掃情報表示"
          onClick={() => redirect(`/cleanHistory/show/${id}`)}
          startIcon={<VisibilityIcon />}
        />
      </TopToolbar>
    </Box>
  );

  // 担当者一覧管理
  const [staffList, setStaffList] = useState([]);
  const [openStaffModal, setOpenStaffModal] = useState(false);
  const [newStaffName, setNewStaffName] = useState("");

  useEffect(() => {
    fetchStaffList().then(setStaffList);
  }, [openStaffModal]);

  const handleAddStaff = async () => {
    if (!newStaffName.trim()) return;
    await addStaff(newStaffName);
    setNewStaffName("");
    setOpenStaffModal(false);
  };

  const handleDeleteStaff = async (dbId) => {
    await deleteStaff(dbId);
    setOpenStaffModal(false);
  };

  return (
    <>
      <CustomTopToolbar />
      <Edit mutationMode="pessimistic"
        transform={(data) => {
          const transformedData = {
            ...data,
            invoiceAmount: invoiceAmount || 0
          };
          return transformedData;
        }}
        mutationOptions={{
          onSuccess: () => {
            notify('更新が完了しました', { type: 'success' });
            window.history.back();
            // redirect('list', 'cleanHistory');
          }
        }}
      >
        <SimpleForm
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
        >
          <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id,
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            onChange={(e) => setCustomerId(e)}
            validate={required()}
            allowEmpty
            freeSolo
          />
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <DateInput source="cleaningDate" label="清掃日" style={{ marginRight: "10px" }} inputProps={{ max: '9999-12-31' }} />
            <TextInput
              source="pumpingAmount"
              label="汲取予定量【㎥】"
              type="number"
              style={{ marginLeft: "10px", marginRight: "10px" }}
              disabled={!customerId}
              defaultValue={customers.find(req => req.id === customerId)?.exPumpingAmount}
            />
            <SelectInput
              source="cleanRange"
              label="清掃範囲"
              choices={cleanRangeChoices}
              style={{ marginLeft: "10px" }}
            />
          </div>

          <TextInput source="content" label="清掃内容" multiline rows={5} />
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <div style={{ flex: 2, marginRight: "10px" }}>
              <SelectInput source="staffName" label="担当者名1" choices={staffList} />
            </div>
            <div style={{ flex: 2, marginLeft: "10px", marginRight: "10px" }}>
              <SelectInput source="staffName2" label="担当者名2" choices={staffList} />
            </div>
            <button type="button" style={{ flex: 1, margin: "auto 0", marginLeft: "10px" }} onClick={() => setOpenStaffModal(true)} >担当者一覧</button>
          </div>

          <StaffModal
            open={openStaffModal}
            staffList={staffList}
            newStaffName={newStaffName}
            setNewStaffName={setNewStaffName}
            handleAddStaff={handleAddStaff}
            handleDeleteStaff={handleDeleteStaff}
            onClose={() => setOpenStaffModal(false)}
          />
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <TextInput
              source="pumpingPay"
              label="金額"
              style={{ marginRight: "10px" }}
              onChange={(e) => setPumpingPay(Number(e.target.value) || 0)}
            />
            <TextInput
              source="pumpingWeigh"
              label="汲取実量(請求量)【㎥】"
              style={{ marginLeft: "10px" }}
              onChange={(e) => setPumpingWeigh(Number(e.target.value) || 0)}
            />
          </div>
          {/* {invoiceId ? (
              <>
              <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
                <DateInput source="invoiceDate" label="請求日" style={{marginRight:"10px"}}/>
                <TextInput source="invoiceAmount" label="請求金額(税抜き)" style={{marginLeft:"10px",marginRight:"10px"}}/>
                <SelectInput source="payMethod" label="支払い方法" choices={[
                  { id: "持参", name: "持参" },
                  { id: "振り込み", name: "振り込み" },
                  { id: "集金", name: "集金" }
                ]} style={{marginLeft:"10px"}}/>
              </div>
              <DateInput source="reissueDate" label="再発行日" />
              <RadioButtonGroupInput
                source="isPay"
                label="領収"
                choices={[
                  { id: 1, name: '領収済み' },
                  { id: 0, name: '未領収' }
                ]}
                defaultValue={isPay}
                validate={required()}
                onChange={(e) => setIsPay(Number(e.target.value))}
              />
              <DateInput source="receiptDate" label="領収日" disabled={!isPay}/>
              <FileInput source="documentURL" label="請求書" accept="application/pdf, image/*">
                <FileField source="src" title="title" />
              </FileInput>
            </>
          ) : (
            <>
            <SelectInput 
              source="isNew"
              label="請求情報"
              choices={[
                { id: -1, name: "後から追加" },
                { id: 1, name: "新規追加" },
                { id: 0, name: "請求履歴から選択" }
              ]}
              validate={required()}
              defaultValue={-1}
              onChange={(e) => setisNew(e.target.value)}
            />
            {isNew === -1 ? (
              <></>
            ) : (
              <> */}
          <Divider sx={{ my: 2 }} /> {/* セクション区切り */}
          <Typography variant="h6">請求情報</Typography>
          {/* {isNew === 1 ? ( */}
          <>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <input type="hidden" name="invoiceId" />
              <DateInput source="invoiceDate" label="請求日" style={{ marginRight: "10px" }} inputProps={{ max: '9999-12-31' }} />
              <TextInput
                source="invoiceAmount"
                label="請求金額(税抜き)"
                style={{ marginLeft: "10px", marginRight: "10px" }}
                disabled={true}
                format={(value) => {
                  return invoiceAmount.toLocaleString();
                }}
                onChange={(e) => setInvoiceAmount(Number(e.target.value) || 0)}

              />
              <SelectInput source="payMethod" label="支払い方法" choices={[
                { id: "持参", name: "持参" },
                { id: "振り込み", name: "振り込み" },
                { id: "集金", name: "集金" }
              ]} style={{ marginLeft: "10px" }} />
            </div>
            <DateInput source="reissueDate" label="再発行日" inputProps={{ max: '9999-12-31' }} />
            <RadioButtonGroupInput
              source="isPay"
              label="領収"
              choices={[
                { id: 1, name: '領収済み' },
                { id: 0, name: '未領収' }
              ]}
              defaultValue={isPay}
              validate={required()}
              onChange={(e) => setIsPay(Number(e.target.value))}
            />
            <DateInput source="receiptDate" label="領収日" disabled={!isPay} inputProps={{ max: '9999-12-31' }} />
            <FileInput source="documentURL" label="請求書" accept="application/pdf, image/*">
              <FileField source="src" title="title" />
            </FileInput>
          </>
          {/* ) : (
               <AutocompleteInput
                source="invoiceId"
                label="請求履歴"
                choices={invoiceHistory.map(req => ({
                  id: req.invoiceId, 
                  name: `請求No.${String(req.id).padStart(5, "0")}（請求日：${(new Date(req.invoiceDate)).toLocaleDateString('ja-JP')}）`
                }))}
                disabled={!customerId}
                allowEmpty
                freeSolo  
              />
            )}
            </>
            )}
            </>
          )} */}
        </SimpleForm>
      </Edit>
    </>
  )

};

export default CleanHistoryEdit;
